import { SET_EMAIL } from "../../../constants/ClientConstants";

export default function setEmailAction(email: string) {
    return {
        type: SET_EMAIL,
        email
    };
}
